import React from 'react';
import Categories from '@/constants/categories';

export const SAVE_CODE_SALE_TEXT = `Save 15% with code TAKEASEAT`;
export const SAVE_CODE_SALE_TEXT_CHECKOUT = 'Use code TAKEASEAT';

export const pad = n => {
  return n < 10 ? '0' + n : n;
};

export const formatDate = date => {
  const month = date.getUTCMonth() + 1; //months from 1-12
  const day = date.getUTCDate();
  const year = date.getUTCFullYear();
  return pad(month) + '/' + pad(day) + '/' + year;
};

export const formatDateToDB = date => {
  var year = date.getFullYear();

  var month = (1 + date.getMonth()).toString();
  month = month.length > 1 ? month : '0' + month;

  var day = date.getDate().toString();
  day = day.length > 1 ? day : '0' + day;

  return `${year}-${month}-${day}`;
};

export const formatDateToDBNoTime = date => {
  let newDate = date.split('/');
  return `${newDate[2]}-${newDate[0]}-${newDate[1]}`;
};

export const getProductImage = product => {
  if (product.is_swatch && product.fabric) {
    return product.fabric.image;
  } else if (product.images.length > 0) {
    return product.images[0]?.path;
  } else {
    return '';
  }
};

export const roundNumber = number => {
  return parseFloat(Math.round(number * 100) / 100).toFixed(2);
};

// removes everything after |
export const getName = name => {
  const index = name.indexOf('|');
  return name.substring(0, index != -1 ? index : name.length);
};

// returns full name product ex: Modern Platform Bed in Fabric Name by Collaborator, Queen Size, Brass Legs
export const getProductFullName = ({
  productName,
  sizeName,
  legName,
  fabricName,
  collaboratorName,
  orientationName
}) => {
  const fabricNameIn = fabricName ? ` in ${fabricName}` : '';
  const collaboratorBy = collaboratorName ? ` by ${collaboratorName}` : '';
  const sizeText = sizeName ? `, ${sizeName} Size` : '';
  const legText = legName ? `, ${legName} Legs` : '';
  const orientationText = orientationName
    ? `, ${orientationName} Orientation`
    : '';
  return `${productName}${fabricNameIn}${collaboratorBy}${sizeText}${legText}${orientationText}`;
};

export const getPaymentMethodName = paymentMethodNumber => {
  switch (paymentMethodNumber) {
    case 1:
      return 'Credit Card';
    case 2:
      return 'Affirm';
    case 3:
      return 'Amazon Pay';
    case 4:
      return 'PayPal';
    case 5:
      return 'Apple Pay';
    case 6:
      return 'Gift Card + Discount';
    case 7:
      return 'Gift Card';
    case 8:
      return 'Discount';
    case 9:
      return 'Google Pay';
    case 10:
      return 'Havenly - No Payment Required';
    default:
      return 'Credit Card';
  }
};

/**
 * Check is the customer role is Havenly
 * @param user
 * @returns {boolean}
 */
export const isHavenlyCustomer = userRole => {
    return Number(userRole) === 6 || Number(userRole) === 5;
}

//removes everything after the dot .
export const getPrice = price => {
  if (!price) return;
  price = price.toString();
  const index = price.indexOf('.');
  return price.substring(0, index != -1 ? index : price.length);
};

//get front image and side image, used on accounts, categories and collaborators
export const productFrontImage = images => {
  return images.length && images[0]
    ? images[0]?.path
    : 'https://theinside.imgix.net/common/missing-image.jpg';
};

export const productSideImage = images => {
  return images.length && images[1]
    ? images[1]?.path
    : images.length && images[0]
    ? images[0]?.path
    : 'https://theinside.imgix.net/common/missing-image.jpg';
};

export const filterProducts = (
  products,
  selectedColorsIds,
  selectedMaterialsIds,
  selectedPatternsIds,
  isKidFriendly
) => {
  return products.filter(product => {
    const { fabric } = product;
    const checkSelectedColors =
      selectedColorsIds.length === 0
        ? true
        : fabric.colors.some(color =>
            selectedColorsIds.includes(`color-${color.id}`)
          );

    const checkSelectedMaterials =
      selectedMaterialsIds.length === 0
        ? true
        : selectedMaterialsIds.includes(`material-${fabric.material.id}`);

    const checkSelectedPatterns =
      selectedPatternsIds.length === 0
        ? true
        : selectedPatternsIds.includes(`pattern-${fabric.pattern.id}`);

    const checkKidFriendly = isKidFriendly ? fabric.is_kid : true;

    return !!(checkKidFriendly &&
      checkSelectedColors &&
      checkSelectedMaterials &&
      checkSelectedPatterns);
  });
};

//fabrics not swatches.
export const filterFabrics = (
  fabrics,
  selectedColorsIds,
  selectedMaterialsIds,
  selectedPatternsIds,
  isKidFriendly
) => {
  return fabrics.filter(fabric => {
    const checkSelectedColors =
      selectedColorsIds.length === 0
        ? true
        : fabric.colors.some(color =>
            selectedColorsIds.includes(`color-${color.id}`)
          );

    const checkSelectedMaterials =
      selectedMaterialsIds.length === 0
        ? true
        : selectedMaterialsIds.includes(`material-${fabric.material.id}`);

    const checkSelectedPatterns =
      selectedPatternsIds.length === 0
        ? true
        : selectedPatternsIds.includes(`pattern-${fabric.pattern.id}`);

    const checkKidFriendly = isKidFriendly ? fabric.is_kid : true;

    if (
      checkKidFriendly &&
      checkSelectedColors &&
      checkSelectedMaterials &&
      checkSelectedPatterns
    )
      return true;
    else {
      return false;
    }
  });
};

//fabrics not swatches.
export const filterFabricsPdp = (
  fabrics,
  selectedColorsIds,
  selectedMaterialsIds,
  selectedPatternsIds,
  isKidFriendly,
  inStockOnly
) => {
  return fabrics.filter(fabric => {
    const checkSelectedColors =
      selectedColorsIds.length === 0
        ? true
        : fabric.colors.some(color =>
            selectedColorsIds.includes(`color-${color.id}`)
          );

    const checkSelectedMaterials =
      selectedMaterialsIds.length === 0
        ? true
        : selectedMaterialsIds.includes(`material-${fabric.material.id}`);

    const checkSelectedPatterns =
      selectedPatternsIds.length === 0
        ? true
        : selectedPatternsIds.includes(`pattern-${fabric.pattern.id}`);

    const checkKidFriendly = isKidFriendly ? fabric.is_kid : true;
    const checkInStockOnly = inStockOnly
      ? fabric.is_product_sold_out == 0
      : true;

    return !!(checkKidFriendly &&
      checkInStockOnly &&
      checkSelectedColors &&
      checkSelectedMaterials &&
      checkSelectedPatterns);
  });
};

export const isUrl = str => {
  const regexp = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
  if (regexp.test(str)) {
    return true;
  } else {
    return false;
  }
};

export const numberFormat = (number, decimals, decPoint, thousandsSep) => {
  number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
  var n = !isFinite(+number) ? 0 : +number;
  var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
  var sep = typeof thousandsSep === 'undefined' ? ',' : thousandsSep;
  var dec = typeof decPoint === 'undefined' ? '.' : decPoint;
  var s = '';

  var toFixedFix = function(n, prec) {
    if (('' + n).indexOf('e') === -1) {
      return +(Math.round(n + 'e+' + prec) + 'e-' + prec);
    } else {
      var arr = ('' + n).split('e');
      var sig = '';
      if (+arr[1] + prec > 0) {
        sig = '+';
      }
      return (+(
        Math.round(+arr[0] + 'e' + sig + (+arr[1] + prec)) +
        'e-' +
        prec
      )).toFixed(prec);
    }
  };

  // @todo: for IE parseFloat(0.55).toFixed(0) = 0;
  s = (prec ? toFixedFix(n, prec).toString() : '' + Math.round(n)).split('.');
  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
  }
  if ((s[1] || '').length < prec) {
    s[1] = s[1] || '';
    s[1] += new Array(prec - s[1].length + 1).join('0');
  }

  return s.join(dec);
};

export const capitalize = s => {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const extractCSStoHTML = () => {
  if (isPrerenderBrowser()) {
    var cssStyles = '';
    for (let i = 0; i < document.styleSheets.length - 1; i++) {
      let style = null;
      let styleSheet = document.styleSheets[i];
      if (styleSheet.href == null && styleSheet.ownerNode.textContent == '') {
        style = styleSheet.rules;
      }
      for (let item in style) {
        if (style[item].cssText != undefined) {
          cssStyles += style[item].cssText;
        }
      }
    }
    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.getElementById('styles-for-prerender');
    if (style) {
      style.setAttribute(
        'iteration',
        parseInt(style.getAttribute('iteration')) + 1
      );
      while (style.firstChild) {
        style.removeChild(style.firstChild);
      }
    } else {
      style = document.createElement('style');
      style.setAttribute('iteration', '1');
      head.appendChild(style);
      style.id = 'styles-for-prerender';
      style.type = 'text/css';
    }
    style.appendChild(document.createTextNode(cssStyles));
  }
};

export const isPrerenderBrowser = () => {
  return (
    typeof navigator != 'undefined' &&
    (navigator.userAgent.includes('Prerender') ||
      navigator.userAgent.includes('prerender'))
  );
};

// hides tablecloth sizes - to delete when we fixed issue.
export const checkIfSizeExists = size => {
  //FRAMES TO HIDE
  const frameSizesToHide = [7, 8, 9, 10, 11, 12, 13];
  return frameSizesToHide.every(x => x != size);
};

export const monthNames = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sept',
  'Oct',
  'Nov',
  'Dec'
];

export const fullMonthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
];

export const shortDayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thur', 'Fri', 'Sat'];

export const dayNames = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday'
];

//FORMAT MM/dd/yyyy
export function getMonthNameDayAndYear(date) {
  let newDate = date.split(' ')[0];
  if (newDate.includes('-')) {
    newDate = newDate.split('-');
    return `${monthNames[parseInt(newDate[1], 10) - 1]} ${newDate[2]}, ${
      newDate[0]
    }`;
  } else {
    newDate = newDate.split('/');
    return `${monthNames[parseInt(newDate[0], 10) - 1]} ${newDate[1]}, ${
      newDate[2]
    }`;
  }
}

//FORMAT MM/yyyy
export function getMonthAndYear(date) {
  let newDate = date.split(' ')[0];
  if (newDate.includes('-')) {
    newDate = newDate.split('-');
    return `${monthNames[parseInt(newDate[1], 10) - 1]} ${newDate[0]}`;
  } else {
    newDate = newDate.split('/');
    return `${monthNames[parseInt(newDate[1], 10) - 1]} ${newDate[2]}`;
  }
}

//FORMAT MM d/yyyy
export function getFullMonthNameDayAndYear(date) {
  if (!date) {
    return false;
  }

  let params1 = date.split(' ');
  let params2 = params1[0].split('-');
  let newDate = `${fullMonthNames[parseInt(params2[1], 10) - 1]} ${parseInt(
    params2[2]
  )}, ${params2[0]}`;

  if (params1.length == 2) {
    newDate = newDate + ' ' + params1[1];
  }

  return newDate;
}

export function getTimeLeftSwatches() {
  const now = new Date();
  const utcNow = Date.UTC(
    now.getUTCFullYear(),
    now.getUTCMonth(),
    now.getUTCDate(),
    now.getUTCHours(),
    now.getUTCMinutes(),
    now.getUTCSeconds()
  );
  let utc10pm = Date.UTC(
    now.getUTCFullYear(),
    now.getUTCMonth(),
    now.getUTCDate(),
    22,
    0,
    0
  );

  if (utcNow > utc10pm) {
    now.setDate(now.getDate() + 1);
    utc10pm = Date.UTC(
      now.getUTCFullYear(),
      now.getUTCMonth(),
      now.getUTCDate(),
      22,
      0,
      0
    );
  }

  const diff = (utc10pm - utcNow) / 1000 / 60 / 60;
  const hours = parseInt(Math.floor(diff), 10);
  const minutes = parseInt((diff * 60) % 60, 10);
  return `${hours}HRS + ${minutes}MINS`;
}

export function getDayMonth(days) {
  const now = new Date();
  now.setDate(now.getDate() + days);
  const monthDay = now.getDate();
  const monthName = monthNames[now.getMonth()];
  const dayName = shortDayNames[now.getDay()];
  return `${dayName}, ${monthName} ${monthDay}`;
}

// FORMAT 'MM/DD/YYYY
export function getFormattedDate(date) {
  var year = date.getFullYear();

  var month = (1 + date.getMonth()).toString();
  month = month.length > 1 ? month : '0' + month;

  var day = date.getDate().toString();
  day = day.length > 1 ? day : '0' + day;

  return month + '/' + day + '/' + year;
}

export function getDateDaysAgo(daysAgo) {
  const now = new Date();
  now.setDate(now.getDate() - daysAgo);
  return getFormattedDate(now);
}

//FORMAT MM/dd/yyyy HH:mm
export function getFormattedDateWithHour(date) {
  const now = new Date(date);

  const sp = num => num.toString().padStart(2, '0');
  return `${sp(now.getMonth() + 1)}/${sp(now.getDate())}/${sp(
    now.getFullYear()
  )} ${sp(now.getHours())}:${sp(now.getMinutes())}`;
}

export function makeRandomId(length) {
  var result = '';
  var characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

export const getImgixUrl = imgUrl => {
  if (typeof imgUrl !== 'string') return '';
  if (!imgUrl) return 'https://theinside.imgix.net/common/missing-image.jpg';

  if (imgUrl.includes('d2qm13qfzc3hs7')) {
    return imgUrl
      .replace(
        'https://d2qm13qfzc3hs7.cloudfront.net',
        'https://theinside.imgix.net'
      )
      .replace('_250', '');
  } else if (imgUrl.includes('https://th3insid3.s3.amazonaws.com')) {
    return imgUrl
      .replace(
        'https://th3insid3.s3.amazonaws.com',
        'https://static.theinside.com'
      )
  } else {
    return imgUrl
      .replace(
        'https://cloudfront.theinside.com',
        'https://theinside.imgix.net'
      )
      .replace('_thumbnail', '');
  }
};

export const getFileNameTrade = url => {
  // get everything after last /
  if (url === '') {
    return url;
  }
  const parts = url.split('/');
  const result = parts[parts.length - 1];

  // get file name
  const reverseResult = result.split('').reverse();
  const IdxLastUnderscore = reverseResult.findIndex(x => x === '_');
  const filename = reverseResult
    .slice(IdxLastUnderscore + 1, reverseResult.length)
    .reverse()
    .join('');

  // get extension name
  const splitExtension = result.split('.');
  const extension = splitExtension[splitExtension.length - 1];

  return `${filename}.${extension}`;
};

export const getSection = slug => {
  let section = '/categories';

  if (['beds', 'headboards', 'benches'].includes(slug)) {
    section = '/bedroom-furniture';
  } else if (
    [
      'sofas',
      'sectional-sofas',
      'chairs',
      'benches',
      'ottomans',
      'cocktail-ottomans'
    ].includes(slug)
  ) {
    section = '/living-room-furniture';
  } else if (['dining-chairs'].includes(slug)) {
    section = '/dining-room';
  } else if (
    [
      'throw-pillows',
      'wallpaper',
      'screens',
      'tabletop',
      'lampshades'
    ].includes(slug)
  ) {
    section = '/home-decor';
  } else if (
    [
      'outdoor',
      'cabana-chairs',
      'cabana-stools',
      'cabana-bundles',
      'outdoor-pillows'
    ].includes(slug)
  ) {
    section = '/outdoor-furniture';
  }

  return section;
};

export const calculateDelayedDays = estimatedDeliveryDate => {
  const today = new Date();
  estimatedDeliveryDate = new Date(estimatedDeliveryDate + 'T00:00:00');
  const delayedDays = Math.floor(
    (today - estimatedDeliveryDate) / (1000 * 60 * 60 * 24)
  );

  if (delayedDays < 1) {
    return 0;
  }

  return delayedDays;
};

export const formatNumberAsCurrency = number => {
  if (isNaN(number)) {
    return number;
  }
  return '$' + numberFormat(number, 2, '.', ',');
};
export function flatten(ary) {
  var ret = [];
  for (var i = 0; i < ary.length; i++) {
    if (Array.isArray(ary[i])) {
      ret = ret.concat(flatten(ary[i]));
    } else {
      ret.push(ary[i]);
    }
  }
  return ret;
}

export const formatNumberAsPercentage = number => {
  if (isNaN(number)) {
    return number;
  }

  return numberFormat(number * 100, 2, '.', ',') + '%';
};

export function daysUntilNow(from) {
  const day = 24 * 60 * 60 * 1000;
  const timeBetween = new Date().getTime() - new Date(from).getTime();
  return timeBetween / day;
}

export function linkify(text) {
  const pattern = /\{([^\}]*),([^\}]*)\}/gim;

  return text.replace(
    pattern,
    '<a href="$2" title="$1" target="_blank">$1</a>'
  );
}

export const checkIsRug = str => {
  if (!str) {
    return false;
  }

  const hasTheWordRug = str.toLowerCase().includes('rug');
  if (hasTheWordRug) {
    return true;
  } else {
    return false;
  }
};

export const checkIsPad = str => {
  if (!str) {
    return false;
  }
  const hasTheWordPad = str.toLowerCase().includes('rug pad');
  if (hasTheWordPad) {
    return true;
  } else {
    return false;
  }
};

export const checkIsOutdoorRug = str => {
  if (!str) {
    return false;
  }
  const hasTheWordOutdoor = str.toLowerCase().includes('outdoor');
  if (hasTheWordOutdoor) {
    return true;
  } else {
    return false;
  }
};

export const checkIsThrowPillow = primarySubcategory =>
  Number(primarySubcategory?.category_id) === Categories.THROW_PILLOW;

export const getFoundationSlug = (frameId, sizeId) => {
  if (
    [
      4,
      5,
      6,
      7,
      39,
      40,
      41,
      42,
      53,
      54,
      55,
      56,
      389,
      390,
      391,
      392,
      393,
      394,
      395,
      396,
      584,
      585,
      586,
      587,
      673,
      674,
      675,
      676,
      677,
      678,
      679,
      680,
      681,
      683,
      684,
      682,
      685,
      686,
      687,
      688
    ].includes(parseInt(frameId))
  ) {
    let slug = null;
    if (sizeId == 2) {
      slug = 'the-foundation-twin-41197';
    } else if (sizeId == 3) {
      slug = 'the-foundation-queen-41199';
    } else if (sizeId == 4) {
      slug = 'the-foundation-full-41198';
    } else if (sizeId == 5) {
      slug = 'the-foundation-king-41200';
    }

    return slug;
  }
};

export const showThePerfectMatchModule = frameId => {
  return [14, 38, 52, 558, 654].includes(parseInt(frameId));
};

export const getFabricFullName = fabric => {
  if (!fabric) return `not a fabric object`;
  const fabricName = fabric.name;
  const collaboratorName = fabric?.collaborator?.name;
  const collaboratorText = collaboratorName ? ` by ${collaboratorName}` : '';
  return `${fabricName}${collaboratorText}`;
};

export const breakTextIntoSeparatedLines = text => {
  return text
    .split(/(?:\r\n|\r|\n)/g)
    .map((t, index) => <div key={index}>{t}</div>);
};

export function csvToArray(str, delimiter = ',') {
  // slice from start of text to the first \n index
  // use split to create an array from string by delimiter
  const headers = str.slice(0, str.indexOf('\n')).split(delimiter);

  // remove spaces from headers
  headers.forEach((header, i) => {
    headers[i] = header.trim();
  });

  // slice from \n index + 1 to the end of the text
  // use split to create an array of each csv value row
  const rows = str.slice(str.indexOf('\n') + 1).split('\n');

  // Map the rows
  // split values from each row into an array
  // use headers.reduce to create an object
  // object properties derived from headers:values
  // the object passed as an element of the array
  const arr = rows.map(function(row) {
    const values = row.split(delimiter);
    const el = headers.reduce(function(object, header, index) {
      let value = values[index];
      // if value is a str and includes /r or /n, remove it
      if (
        typeof value === 'string' &&
        (value.includes('\r') || value.includes('\n'))
      ) {
        value = value.replace(/\r?\n|\r/g, '');
      }
      object[header] = value;
      return object;
    }, {});
    return el;
  });

  // return the array
  return arr;
}

export function toImgixUrl(str) {
  if (str.includes('cloudfront.theinside.com')) {
    return str.replace('cloudfront.theinside.com', 'theinside.imgix.net');
  }

  return str;
}
